<template>
  <v-container fluid class="full-container financial-container">
    <v-row class="tabs-root">
      <v-toolbar flat fixed class="tabs-toolbar">
        <v-tabs
          v-model="tab"
          show-arrows
          grow
        >
          <v-tabs-slider/>
          <v-tab :href="`#${tabs()[0]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.financial.pages.summary.icon }}</v-icon>
            {{ lang.meta.pages.financial.pages.summary.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[1]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.financial.pages.cash_flow.icon }}</v-icon>
            {{ lang.meta.pages.financial.pages.cash_flow.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[2]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.financial.pages.bills.icon }}</v-icon>
            {{ lang.meta.pages.financial.pages.bills.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[3]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.financial.pages.salary.icon }}</v-icon>
            {{ lang.meta.pages.financial.pages.salary.title }}
          </v-tab>
          <v-tab :href="`#${tabs()[4]}`">
            <v-icon class="pr-2">{{ lang.meta.pages.financial.pages.reports.icon }}</v-icon>
            {{ lang.meta.pages.financial.pages.reports.title }}
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-row>
    <v-row class="blank-toolbar" style="height: 25px !important;"> </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item :id="tabs()[0]">
            <Overview />
          </v-tab-item>
          <v-tab-item :id="tabs()[1]">
            <CashFlow />
          </v-tab-item>
          <v-tab-item :id="tabs()[2]">
            <Bills />
          </v-tab-item>
          <v-tab-item :id="tabs()[3]">
            <Salary />
          </v-tab-item>
          <v-tab-item :id="tabs()[4]">
            <Reports />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Overview from '@/components/financial/overview/Overview'
import CashFlow from '@/components/financial/cashflow/CashFlow'
import Bills from '@/components/financial/bills/Bills'
import Salary from '@/components/financial/salary/Salary'
import Reports from '@/components/financial/reports/Reports'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import tabs from '@/mixins/defaults/tabs'

export default {
  components: { Overview, CashFlow, Bills, Salary, Reports },
  mixins: [ appdata, utils, tabs ],
  data () {
    return {
      tabs () {
        return [
          this.lang.meta.pages.financial.pages.summary.path,
          this.lang.meta.pages.financial.pages.cash_flow.path,
          this.lang.meta.pages.financial.pages.bills.path,
          this.lang.meta.pages.financial.pages.salary.path,
          this.lang.meta.pages.financial.pages.reports.path
        ]
      }
    }
  },
  created () {
    //this.$store.dispatch('socket/CUSTOM_DATA', { ...this.get_global.filters })
  }
}
</script>

<style src="@/components/financial/styles/index.scss" lang="scss"></style>